import { Environment } from '@viso/core/models';

export const environment: Environment = {
  API_URL: 'https://api.uat.viso.events/KaaryamAPI/public/api',
  SOCKET_URL: 'https://chat.uat.viso.events/',
  // API_URL: 'http://127.0.0.1:8000/api',
  // SOCKET_URL: 'http://localhost:8080',
  deepLinkUrl: 'inviteuat.ootbo.com',
  // shareBaseUrl: 'https//localhost:4200',
  shareBaseUrl: 'https://m.uat.ootbo.com',
  production: false,
  resendOtpTimeoutInSeconds: 90,
  firebaseConfig: {
    apiKey: 'AIzaSyBdN1VCk3aC03xWuMyjx4iTc5zfGxs0dxo',
    authDomain: 'visoeventsdev.firebaseapp.com',
    databaseURL: 'https://visoeventsdev-default-rtdb.firebaseio.com/',
    projectId: 'visoeventsdev',
    storageBucket: 'visoeventsdev.firebasestorage.app',
    messagingSenderId: '124762745753',
    appId: '1:124762745753:web:a21298a22bcc5be8ab8108',
    measurementId: 'G-0L01ZN23CE'
  },
  googleOAuthConfig: {
    clientId: '124762745753-af77s2i4qiu6lv4o38u4pbmcjss7714q.apps.googleusercontent.com',
  },
  googleWebClientId: '124762745753-af77s2i4qiu6lv4o38u4pbmcjss7714q.apps.googleusercontent.com',
  googleIOSClientId: '124762745753-0b6b5hlloeeevtumrcb9dcigb8uqcp9j.apps.googleusercontent.com',
  appleClientId: 'viso.events.vendor'
};